import { z } from 'zod';

import { TsrctRecommendationDecisionStatus } from '@/generated/gql/graphql';

export const demandRecommendationFormDataSchema = z.object({
  demandRequestItems: z.array(
    z.object({
      recommendations: z.array(
        z.object({
          decisionStatus: z.enum(TsrctRecommendationDecisionStatus),
          id: z.string(),
          isDirty: z.boolean(),
        }),
      ),
    }),
  ),
});
export type DemandRecommendationFormData = z.infer<typeof demandRecommendationFormDataSchema>;

export const demandRecommendationFormDataDefault = {
  demandRequestItems: [],
};

export type RecommendationType = DemandRecommendationFormData['demandRequestItems'][number]['recommendations'][number];

export const isRecommendationType = (value: any): value is RecommendationType => {
  return value && typeof value === 'object' && value.decisionStatus;
};
